import {Splide} from '@splidejs/splide';
import {Video} from "@splidejs/splide-extension-video";

export default class HeaderSlider {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const self = this;
        var splide_element = document.querySelector('.header-slider');
        if (splide_element) {
            var interval = splide_element.dataset.interval;
            if (interval == null) {
                interval = 10000;
            }
            let splide = new Splide(splide_element, {
                'type': 'loop',
                'autoplay': true,
                'pagination': false,
                'interval': interval,
                'video': {
                    'autoplay': true,
                    'mute': true,
                    'loop': true,
                    'disableOverlayUI': true,
                    'hideControls': true
                }
            });
            splide.mount({Video});
        }
    }
}